export const createSideOrdersArray = (
  data: Record<
    string,
    Record<string, Record<number, { amount: number; name: string }>>
  >
) => {
  const sideOrdersArray: string[] = [];
  Object.values(data)
    .map(days =>
      Object.values(
        days['sideOrders'] as Record<number, { amount: number; name: string }>
      )
    )
    .forEach(sideOrders =>
      sideOrders.forEach(possibleSideOrder => {
        if (possibleSideOrder.amount) {
          sideOrdersArray.push(possibleSideOrder.name);
        }
      })
    );
  // TODO ts-ignore
  // @ts-ignore
  return [...new Set(sideOrdersArray)];
};
